import React from 'react';
import PropTypes from 'prop-types';

import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { RED } from '../../../../../theme/colorConstants';

const StandardErrorBox = ({ message, sx }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        marginTop: theme.spacing(2),
        padding: theme.spacing(1.5),
        backgroundColor: RED[10],
        borderRadius: theme.spacing(1),
        ...sx,
      }}
    >
      <ErrorOutlineIcon sx={{ color: RED[50] }} />
      <Typography sx={{ color: RED[50], fontSize: '16px' }}>{message}</Typography>
    </Box>
  );
};

StandardErrorBox.propTypes = {
  message: PropTypes.node.isRequired,
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

StandardErrorBox.defaultProps = {
  sx: {},
};

export default StandardErrorBox;
